import * as React from 'react';
import { runInAction } from 'mobx';
import { observer, useLocalStore } from 'mobx-react-lite';
import PipelineStep from '../../pipeline_base/models/PipelineStep';
import { ConnectionsDefinitionsService } from '../../iota_connections/services';
import PipelineVisualStore from '../stores/PipelineVisualStore';
import { Parameter } from '../types';
import { Select } from 'antd';
import { ConnectionsDefinition } from '../../iota_connections/types';
import Form, { FormInstance } from 'antd/lib/form';

const Option = Select.Option;

type Props<T extends PipelineVisualStore<TPipelineStepType>, TPipelineStepType extends string> = {
    param: Parameter;
    form: FormInstance;
    toolTip: JSX.Element;
    step: PipelineStep<TPipelineStepType>;
    projectId: string;
    store: T;
    stepKey: number;
};
export const ParametersIotaConnectionsPackageSelector: <
    T extends PipelineVisualStore<TPipelineStepType>,
    TPipelineStepType extends string
>(
    props: Props<T, TPipelineStepType>
) => React.ReactElement<Props<T, TPipelineStepType>> = ({ param, form, toolTip, step, store, stepKey, projectId }) => {
    const handleSubmit = async () => {
        await store.validateForm(form, step, stepKey, false);
    };
    if (!store.isFormSubmissionExists(stepKey)) {
        store.setFormSubmision(handleSubmit, stepKey);
    }

    const localState = useLocalStore(() => ({
        service: new ConnectionsDefinitionsService(),
        package: '',
        packages: new Array<ConnectionsDefinition>(),
        async load() {
            var res = await localState.service.getForProject(projectId);
            runInAction(() => {
                localState.packages = res;
            });
        }
    }));

    React.useEffect(() => {
        localState.load();
    }, [localState]);

    return (
        <div>
            <Form.Item
                label={toolTip}
                name={param.name}
                rules={[
                    {
                        required: !step.isDisabled && param.required,
                        message: 'Please select a package'
                    }
                ]}
                initialValue={param.defaultValue}
            >
                <Select style={{ width: '100%' }}>
                    {localState.packages.map(x => (
                        <Option key={x.id} value={x.id}>
                            {x.name}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
        </div>
    );
};

export default observer(ParametersIotaConnectionsPackageSelector);
